import React, { useState, useEffect } from "react";
import Hero from "./sections/Hero";
import AboutUs from "./sections/AboutUs";
import Services from "./sections/Services";
import Clients from "./sections/Clients";
import Collaboration from "./sections/Collaboration";
import { useAnimations } from "./hooks/useAnimations";

const Landing = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const animations = useAnimations(isMobile);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen">
      <Hero
        animations={animations}
        isMobile={isMobile}
        scrollToSection={scrollToSection}
      />
      <AboutUs animations={animations} isMobile={isMobile} />
      <Services animations={animations} isMobile={isMobile} />
      <Clients animations={animations} />
      <Collaboration animations={animations} isMobile={isMobile} />
    </div>
  );
};

export default Landing;
